/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvitationStatusEnumDTO } from './InvitationStatusEnumDTO';
import {
    InvitationStatusEnumDTOFromJSON,
    InvitationStatusEnumDTOFromJSONTyped,
    InvitationStatusEnumDTOToJSON,
} from './InvitationStatusEnumDTO';
import type { OrganizationInvitationProjectEntryDTO } from './OrganizationInvitationProjectEntryDTO';
import {
    OrganizationInvitationProjectEntryDTOFromJSON,
    OrganizationInvitationProjectEntryDTOFromJSONTyped,
    OrganizationInvitationProjectEntryDTOToJSON,
} from './OrganizationInvitationProjectEntryDTO';
import type { InvitationTypeEnumDTO } from './InvitationTypeEnumDTO';
import {
    InvitationTypeEnumDTOFromJSON,
    InvitationTypeEnumDTOFromJSONTyped,
    InvitationTypeEnumDTOToJSON,
} from './InvitationTypeEnumDTO';
import type { OrganizationRoleDTO } from './OrganizationRoleDTO';
import {
    OrganizationRoleDTOFromJSON,
    OrganizationRoleDTOFromJSONTyped,
    OrganizationRoleDTOToJSON,
} from './OrganizationRoleDTO';

/**
 * 
 * @export
 * @interface OrganizationInvitationDTO
 */
export interface OrganizationInvitationDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationDTO
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationDTO
     */
    invitedBy: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationInvitationDTO
     */
    invitee: string;
    /**
     * 
     * @type {InvitationTypeEnumDTO}
     * @memberof OrganizationInvitationDTO
     */
    invitationType: InvitationTypeEnumDTO;
    /**
     * 
     * @type {OrganizationRoleDTO}
     * @memberof OrganizationInvitationDTO
     */
    roleGrant: OrganizationRoleDTO;
    /**
     * 
     * @type {InvitationStatusEnumDTO}
     * @memberof OrganizationInvitationDTO
     */
    status: InvitationStatusEnumDTO;
    /**
     * 
     * @type {Array<OrganizationInvitationProjectEntryDTO>}
     * @memberof OrganizationInvitationDTO
     */
    projects: Array<OrganizationInvitationProjectEntryDTO>;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationInvitationDTO
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationInvitationDTO
     */
    lastSentAt: Date;
}



/**
 * Check if a given object implements the OrganizationInvitationDTO interface.
 */
export function instanceOfOrganizationInvitationDTO(value: object): value is OrganizationInvitationDTO {
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('invitedBy' in value) || value['invitedBy'] === undefined) return false;
    if (!('invitee' in value) || value['invitee'] === undefined) return false;
    if (!('invitationType' in value) || value['invitationType'] === undefined) return false;
    if (!('roleGrant' in value) || value['roleGrant'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('projects' in value) || value['projects'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastSentAt' in value) || value['lastSentAt'] === undefined) return false;
    return true;
}

export function OrganizationInvitationDTOFromJSON(json: any): OrganizationInvitationDTO {
    return OrganizationInvitationDTOFromJSONTyped(json, false);
}

export function OrganizationInvitationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationInvitationDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'organizationName': json['organizationName'],
        'invitedBy': json['invitedBy'],
        'invitee': json['invitee'],
        'invitationType': InvitationTypeEnumDTOFromJSON(json['invitationType']),
        'roleGrant': OrganizationRoleDTOFromJSON(json['roleGrant']),
        'status': InvitationStatusEnumDTOFromJSON(json['status']),
        'projects': ((json['projects'] as Array<any>).map(OrganizationInvitationProjectEntryDTOFromJSON)),
        'createdAt': (new Date(json['createdAt'])),
        'lastSentAt': (new Date(json['lastSentAt'])),
    };
}

export function OrganizationInvitationDTOToJSON(value?: OrganizationInvitationDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationName': value['organizationName'],
        'invitedBy': value['invitedBy'],
        'invitee': value['invitee'],
        'invitationType': InvitationTypeEnumDTOToJSON(value['invitationType']),
        'roleGrant': OrganizationRoleDTOToJSON(value['roleGrant']),
        'status': InvitationStatusEnumDTOToJSON(value['status']),
        'projects': ((value['projects'] as Array<any>).map(OrganizationInvitationProjectEntryDTOToJSON)),
        'createdAt': ((value['createdAt']).toISOString()),
        'lastSentAt': ((value['lastSentAt']).toISOString()),
    };
}

